<div class="compare-version">
  <div class="notification-message-container m-0 m-b-10 flex flex-col">
    <div>Current version published on : <strong *ngIf="latestSummaryRulesSnapshot">{{ latestSummaryRulesSnapshot.publishDate | date:'dd MMMM yyyy' }}</strong></div>
  </div>
  <div class="w-p-100 flex flex-col">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Select Previous Version</mat-label>
      <mat-select [value]="selectedSnapshot" (selectionChange)="onSelectPublicationDate($event)">
        <mat-option *ngFor="let summaryRulesSnapshot of summaryRulesSnapshots" [value]="summaryRulesSnapshot">
          {{summaryRulesSnapshot.publishDate | date: 'dd MMMM yyyy'}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Country</mat-label>
      <mat-select [disabled]="!selectedSnapshot" (selectionChange)="onSelectPublicationCountry($event)">
        <mat-option *ngFor="let publishedCountry of publishedCountries" [value]="publishedCountry">
          {{publishedCountry.displayName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
